







































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import HoldActionTracker from "@/view/hold/components/HoldActionTracker.vue";
import HoldActionItems from "@/domainObjects/hold/HoldActionItems";
import Verification from "@/domainObjects/hold/Verification";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import alertMixin from "@/mixins/alert-mixin";
import {mapGetters} from "vuex";
import LoadingActions from "@/store/actions/loading";
import Disposition from "@/domainObjects/hold/Disposition";


@Component({
    components: {
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
        HoldActionTracker,
    },
    mixins: [alertMixin],
    computed: {
        // TODO: should change to mapState at some point
        ...mapGetters(['getFirstName', 'getLastName', 'getGroups']),
    }
})
export default class ViewHoldTicketPage extends Vue {
    private holdActionItems: HoldActionItems = new HoldActionItems();
    private buttonVariant: string = 'outline-secondary';
    private originalHoldTicketStringified: string = "";
    private holdTicket:HoldTicket = new HoldTicket();
    private ticketChanged: boolean = false;
    private submitButtonText: string = 'Save';
    private errorMessage: string = '';
    private ticketId:number = 0;
    private getFirstName!: string;
    private getLastName!: string;

    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;
    $_alertMixin_swalClose!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;

    @Watch('holdTicket', { immediate: true, deep: true})
    onPropertyChanged(value:HoldTicket, oldvalue: HoldTicket){
        let newHoldTicketStringified = JSON.stringify(value);
        this.ticketChanged = this.originalHoldTicketStringified !== newHoldTicketStringified;
        if (this.ticketChanged){
            this.buttonVariant = 'secondary';
        } else {
            this.buttonVariant = 'outline-secondary'
        }
    }

    created() {
        this.getTicket();
    }

    addRow(){
        let newActionItem = new HoldActionItems();
        newActionItem.holdTicketId = this.holdTicket.holdTicketId;
        newActionItem.verification = new Verification();
        this.holdTicket.holdActionItems.unshift(newActionItem);
    }

    recalculateTotalQty() {
        this.holdTicket.piecesGood = 0;
        this.holdTicket.piecesScrap = 0;
        this.holdTicket.piecesAwaiting = 0;
        this.holdTicket.piecesReturned = 0;
        this.holdTicket.piecesRemaining = 0;
        this.holdTicket.totalReworkHours = 0;

        for (let i = 0; i < this.holdTicket.holdActionItems.length; i++){
            switch(this.holdTicket.holdActionItems[i].verification.id){
                case 1:
                    this.holdTicket.piecesGood = this.holdTicket.piecesGood + parseFloat(String(this.holdTicket.holdActionItems[i].quantity));
                    break;
                case 2:
                    this.holdTicket.piecesScrap =  this.holdTicket.piecesScrap + parseFloat(String(this.holdTicket.holdActionItems[i].quantity));
                    break;
                case 3:
                    this.holdTicket.piecesAwaiting = this.holdTicket.piecesAwaiting + parseFloat(String(this.holdTicket.holdActionItems[i].quantity));
                    break;
                default:
                    this.holdTicket.piecesReturned = this.holdTicket.piecesReturned + parseFloat(String(this.holdTicket.holdActionItems[i].quantity));
            }
            this.holdTicket.totalReworkHours = this.holdTicket.totalReworkHours + parseFloat(String(this.holdTicket.holdActionItems[i].reworkHours));
        }
        this.holdTicket.piecesRemaining = this.holdTicket.quantityOnHold - this.holdTicket.piecesGood - this.holdTicket.piecesScrap - this.holdTicket.piecesAwaiting - this.holdTicket.piecesReturned;
        if (this.holdTicket.piecesRemaining === 0 && this.holdTicket.disposition.id !==Disposition.AWAITING_DISPOSITION && this.holdTicket.status.desc === 'Open') {
            this.submitButtonText = 'Close Ticket';
        } else {
            this.submitButtonText = 'Save';
        }
    }

    actionTrackerIsValid(){
        this.errorMessage = "";
        for (let i = 0; i < this.holdTicket.holdActionItems.length; i++){
            if (this.holdTicket.holdActionItems[i].verification.id === 0 ||
                this.holdTicket.holdActionItems[i].actionItemDate === "" ||
                this.holdTicket.holdActionItems[i].personComplRework.length === 0 ||
                this.holdTicket.holdActionItems[i].actionItemShift.length === 0 ||
                this.holdTicket.holdActionItems[i].locations.length === 0 ||
                this.holdTicket.holdActionItems[i].verifiedBy.length === 0 ||
                this.holdTicket.holdActionItems[i].location.length === 0
                ){
                this.errorMessage = "Please fill out all required fields";
                return false
            }
        }
        return true
    }

    onSubmit() {
        let self = this;
        this.recalculateTotalQty();
        if (this.actionTrackerIsValid()) {
            if (this.holdTicket.piecesRemaining === 0 && this.errorMessage.length === 0 && this.holdTicket.status.desc === 'Open') {
                this.holdTicket.closedBy = this.getFirstName + ' ' + this.getLastName;
                this.holdTicket.closedDate = Date.now();
                this.$_alertMixin_swalClose('Close Ticket?', null, null).then((value) => {
                    if (value) {
                        let holdTicketJSON = JSON.stringify(self.holdTicket);
                        TicketService.closeHoldTicket(holdTicketJSON).then((response) => {
                            self.$_alertMixin_saveSuccess();
                            // @ts-ignore
                            this.$router.push({name: 'hold-tickets', params: {updatedTicket: this.holdTicket, updatedTicketType:'closed', newTicketsFromActionTracker:response.data}})
                            //self.getTicket()
                        }).catch((error) => {

                            self.getTicket()
                        })
                    }
                })
            } else {
                this.$_alertMixin_swalConfirm('Save Action Items?', this.errorMessage, null).then((value) => {
                    if (value) {
                        let holdActionItemsJSON = JSON.stringify(self.holdTicket.holdActionItems);
                        TicketService.saveHoldActionItems(holdActionItemsJSON).then((response) => {
                            self.$_alertMixin_saveSuccess();
                            // @ts-ignore
                            this.$router.push({name: 'hold-tickets', params: {updatedTicket: this.holdTicket, updatedTicketType:'updated'}})
                            //self.getTicket()
                        }).catch((error) => {

                            self.getTicket()
                        })
                    }
                })
            }
        }
    }
    onReset(){
        this.errorMessage = "";
        this.holdTicket.loaded = false;
        this.$nextTick(()=>{
            this.getTicket();
            this.holdTicket.loaded = true;
        })
    }

    getTicket(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.ticketId = parseFloat(this.$route.params['holdTicketId']);
        TicketService.getHoldTicketById(this.ticketId).then((response)=>{
            for (let i = 0; i < response.data.holdActionItems.length; i++){
                if (response.data.holdActionItems[i].newHoldTicketId === 0)
                    response.data.holdActionItems[i].newHoldTicketId = null;
            }
            this.holdTicket = new HoldTicket();
            this.holdTicket.initFromObject(response.data);
            this.originalHoldTicketStringified = JSON.stringify(this.holdTicket);
            this.holdTicket.loaded = true;
            this.recalculateTotalQty();
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

        });
    }
}
